import request from '@/utils/request'

export function getStyleType(data) {
  return request({
    url: 'appmanage/shop/getStyleType',
    method: 'post',
    data
  })
}
export function getBeatsGoods(data) {
  return request({
    url: 'appmanage/shop/getBeatsGoods',
    method: 'post',
    data
  })
}
export function addOrUpdateBeats(data) {
  return request({
    url: 'appmanage/shop/addOrUpdateBeats',
    method: 'post',
    data
  })
}
export function getOrderList(data) {
  return request({
    url: 'appmanage/shop/getOrderList',
    method: 'post',
    data
  })
}
export function putaway(data) {
  return request({
    url: 'appmanage/shop/putaway',
    method: 'post',
    data
  })
}
//外部
export function getBeatsGood(data) {
  return request({
    url: 'appmanage/external/music/getBeatsGoods',
    method: 'post',
    data
  })
}
export function addOrUpdateBeat(data) {
  return request({
    url: 'appmanage/external/music/addOrUpdateBeats',
    method: 'post',
    data
  })
}
export function OrderList(data) {
  return request({
    url: 'appmanage/external/music/OrderList',
    method: 'post',
    data
  })
}
export function deleteBeat(data) {
  return request({
    url: 'appmanage/external/music/deleteBeats',
    method: 'post',
    data
  })
}
export function alterBeat(data) {
  return request({
    url: 'appmanage/external/music/alterBeats',
    method: 'post',
    data
  })
}
export function market(data) {
  return request({
    url: 'appmanage/external/music/market',
    method: 'post',
    data
  })
}




// WEBPACK FOOTER //
// ./src/api/shop.js